import { DiModuleBuilder } from "@di/builder/di-module-builder";
import { ContainerModule } from "inversify";

import { EntityApiKeysDatasource } from "@entity-api-keys/data/datasources/entity-api-keys.datasource";
import { EntityApiKeyMapper } from "@entity-api-keys/data/mappers/entity-api-key.mapper";
import { EntityApiKeysMapper } from "@entity-api-keys/data/mappers/entity-api-keys.mapper";
import { EntityApiKeysRepository } from "@entity-api-keys/data/repositories/entity-api-keys.repository";

import { CreateEntityApiKeyUseCase } from "@entity-api-keys/domain/usecases/create-entity-api-key.usecase";
import { DeleteEntityApiKeyUseCase } from "@entity-api-keys/domain/usecases/delete-entity-api-key.usecase";
import { ExportPublicApiUsageStatsXlsxUseCase } from "@entity-api-keys/domain/usecases/export-public-api-usage-stats-xlsx.usecase";
import { GetEntityApiKeyByIdUseCase } from "@entity-api-keys/domain/usecases/get-entity-api-key-by-id.usecase";
import { GetPublicApiUsageStatsUseCase } from "@entity-api-keys/domain/usecases/get-public-api-usage-stats.usecase";
import { SearchEntityApiKeysUseCase } from "@entity-api-keys/domain/usecases/search-entity-api-keys.usecase";
import { UpdateEntityApiKeyUseCase } from "@entity-api-keys/domain/usecases/update-entity-api-key.usecase";

import { EntityApiKeyFormViewModel } from "@entity-api-keys/presentation/components/entity-api-key-form/entity-api-key-form.viewmodel";
import { CreateEntityApiKeyPageViewModel } from "@entity-api-keys/presentation/pages/create/create-entity-api-key-page.viewmodel";
import { DetailEntityApiKeyPageViewModel } from "@entity-api-keys/presentation/pages/detail/detail-entity-api-key-page.viewmodel";
import { EditEntityApiKeyPageViewModel } from "@entity-api-keys/presentation/pages/edit/edit-entity-api-key-page.viewmodel";
import { EntityApiKeysListPageViewModel } from "@entity-api-keys/presentation/pages/list/entity-api-keys-list-page.viewmodel";
import { PublicApiUsageStatsPageViewModel } from "@entity-api-keys/presentation/pages/usage-stats/public-api-usage-stats-page.viewmodel";

const entityApiKeysModule = new DiModuleBuilder();

entityApiKeysModule.registerSubModules(() => ({
    datasources: new ContainerModule((bind) => {
        bind(EntityApiKeysDatasource).toSelf();
    }),
    mappers: new ContainerModule((bind) => {
        bind(EntityApiKeyMapper).toSelf();
        bind(EntityApiKeysMapper).toSelf();
    }),
    repositories: new ContainerModule((bind) => {
        bind(EntityApiKeysRepository).toSelf();
    }),
    useCases: new ContainerModule((bind) => {
        bind(SearchEntityApiKeysUseCase).toSelf();
        bind(GetEntityApiKeyByIdUseCase).toSelf();
        bind(CreateEntityApiKeyUseCase).toSelf();
        bind(UpdateEntityApiKeyUseCase).toSelf();
        bind(DeleteEntityApiKeyUseCase).toSelf();
        bind(GetPublicApiUsageStatsUseCase).toSelf();
        bind(ExportPublicApiUsageStatsXlsxUseCase).toSelf();
    }),
    viewModels: new ContainerModule((bind) => {
        bind(EntityApiKeyFormViewModel).toSelf();
        bind(EntityApiKeysListPageViewModel).toSelf();
        bind(CreateEntityApiKeyPageViewModel).toSelf();
        bind(EditEntityApiKeyPageViewModel).toSelf();
        bind(DetailEntityApiKeyPageViewModel).toSelf();
        bind(PublicApiUsageStatsPageViewModel).toSelf();
    }),
}));

entityApiKeysModule.registerModule();

export { entityApiKeysModule };
